import { InvitationStatus } from '@compass/client/types/organization';
import { Check, Hourglass, TimerOff, Undo2 } from 'lucide-react';
import React from 'react';

import { Badge } from '@/components/ui/badge';

interface InvitationStatusBadgeProps {
  status?: InvitationStatus;
}

const getStatusConfig = (status?: InvitationStatus) => {
  switch (status) {
    case InvitationStatus.INVITATION_STATUS_PENDING:
      return {
        label: 'Pending',
        icon: Hourglass,
        className: 'bg-notice-muted text-notice-foreground',
      };
    case InvitationStatus.INVITATION_STATUS_ACCEPTED:
      return {
        label: 'Accepted',
        icon: Check,
        className: 'bg-positive-muted text-positive-foreground',
      };
    case InvitationStatus.INVITATION_STATUS_EXPIRED:
      return {
        label: 'Expired',
        icon: TimerOff,
        className: 'bg-attention-muted text-attention-foreground',
      };
    case InvitationStatus.INVITATION_STATUS_REVOKED:
      return {
        label: 'Revoked',
        icon: Undo2,
        className: 'bg-critical-muted text-critical-foreground',
      };
    default:
      return {
        label: 'Unknown',
        icon: null,
        className: 'bg-muted text-muted-foreground',
      };
  }
};

export const InvitationStatusBadge: React.FC<InvitationStatusBadgeProps> = ({ status }) => {
  const config = getStatusConfig(status);
  const Icon = config.icon;

  return (
    <Badge
      variant="outline"
      className={`inline-flex items-center gap-1 border-none ${config.className}`}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {config.label}
    </Badge>
  );
};
